import { Box, IconButton, Menu } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TabFilters from "../../../atoms/tabs-selector";
import { RequestServer } from "../../../utils/services";
import { APIRoutes, SETTINGS_CONFIG_TYPE } from "../../../constants";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";
import SettingsIcon from '@mui/icons-material/Settings';
import { BoxFlex } from "../../../atoms/boxSpaceBtw";
import NotificationSelectionDialog from "../../../organisms/notification_selection";

export const defaultNotificationValues = {
    Payment_Requested: true,
    Payment_On_Hold: true,
    Payment_Rejected: true,
    High_Priority_Payment: true,
    PROJECT_INVITE_ACCEPTED: true,
    PROJECT_INVITE_DECLINED: true,
    PAYMENT_COMPLETED: true,
    PAYMENT_FAILED: true,
    COMPLIANCE_COMPLETED: true,
    HONORARIUM_CHANGED: true,
    TIME_SLOT_SHARED: true
}

export default function NotificationsList({
  open: showNotifications,
  anchorEl,
  handleClose,
  data,
  setData,
  readNotifications,
  unreadNotifications,
  fetchData
}: {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  data: any;
  setData: (data: any) => void;
  readNotifications: Array<any>;
  unreadNotifications: Array<any>;
  fetchData: () => Promise<void>;
}) {
  dayjs.extend(relativeTime);
  const [notificationState, setNotificationState] = useState("Unread");
  const user_settings: Array<any> = JSON.parse(localStorage.getItem("user_settings") || "[]")
  const notificationSettingsinitialData = user_settings.find(u => u.config_type === SETTINGS_CONFIG_TYPE.NotificationEvents)?.config_value || defaultNotificationValues
  const [notificationSettings,setNotificationSettings] = useState({
    state: false,
    data: notificationSettingsinitialData
  });

  const markAllAsRead = async () => {
    const unreadNotificationIDs = unreadNotifications.map(
      (notification: any) => notification.id,
    );
    const res = await RequestServer(
      APIRoutes.NOTIFICATIONS + "/read" + "?ids=" + unreadNotificationIDs.join(","),
      "PATCH",
    );
    if (res.success) {
      setData(
        data.map((notification: any) => {
          if (!notification.read_on) {
            return {
              ...notification,
              read_on: new Date().toISOString().slice(0, 19).replace("T", " "),
            };
          } else {
            return notification;
          }
        }),
      );
    }
  };

  return (
    <React.Fragment>
      <Menu
        anchorEl={anchorEl}
        id="notifications-menu"
        open={showNotifications}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: unreadNotifications.length
                ? "var(--green-color)"
                : "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
            width: "20rem",
            height: "30rem",
            padding: 0,
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box
          sx={{
            height: "30rem",
            padding: 0,
            position: "relative",
          }}
        >
          {unreadNotifications.length > 0 && (
            <Box
              sx={{
                height: "5rem",
                backgroundColor: "var(--green-color)",
                marginTop: "-0.5rem",
                borderRadius: "5px 5px 0 0",
                color: "white",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ fontSize: "1.5rem" }}>
                {unreadNotifications.length}
              </div>
              <div>
                {unreadNotifications.length > 1
                  ? "New Notifications"
                  : "New Notification"}
              </div>
            </Box>
          )}
          <BoxFlex
            sx={{ position: "sticky", top: 0, background: "white", zIndex: 10 }}
          >
            <TabFilters
              onChange={setNotificationState}
              value={notificationState}
              options={["Unread", "All", "Read"]}
              isDeSelectAllowed={false}
            />
            <div style={{paddingRight: "10px"}}>
              <IconButton onClick={() => setNotificationSettings((prev) => ({...prev, state: true}))}>
                <SettingsIcon sx={{color: "var(--primary-color)"}} />
              </IconButton>
            </div>
          </BoxFlex>
          {notificationState === "All" && (
            <Box
              sx={
                unreadNotifications.length > 0
                  ? {
                      position: "relative",
                      height: "100%",
                      maxHeight: unreadNotifications.length ? "20rem" : "25rem",
                      overflowY: "auto",
                    }
                  : {
                      position: "relative",
                      height: "100%",
                      maxHeight: unreadNotifications.length
                        ? "21.5rem"
                        : "26.5rem",
                      overflowY: "auto",
                    }
              }
            >
              {data.length > 0 &&
                data.map((notification: any, index: number) => (
                  <div
                    key={index}
                    onClick={async () => {
                      const res = await RequestServer(
                        APIRoutes.NOTIFICATIONS +
                          "/read" +
                          "?ids=" +
                          notification.id,
                        "PATCH",
                      );
                      if (res.success) {
                        setData(
                          data.map((n: any) =>
                            n.id === notification.id
                              ? {
                                  ...n,
                                  read_on: new Date()
                                    .toISOString()
                                    .slice(0, 19)
                                    .replace("T", " "),
                                }
                              : n,
                          ),
                        );
                      }
                    }}
                    style={
                      notification.read_on
                        ? readNotificationStyle
                        : unreadNotificationStyle
                    }
                    onMouseOver={(e) => {
                      (
                        e.currentTarget.firstChild! as HTMLElement
                      ).style.backgroundColor = "rgba(0,0,0,0.05)";
                    }}
                    onMouseOut={(e) => {
                      (
                        e.currentTarget.firstChild! as HTMLElement
                      ).style.backgroundColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                      }}
                    ></div>
                    {notification.url ? (
                      <>
                        <Link
                          to={notification.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                            position: "relative",
                          }}
                        >
                          <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
                            {notification.title}
                          </div>
                           <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                        </Link>
                        <div>
                          <span>
                            {dayjs(notification.created_at).fromNow()}
                          </span>
                          {!notification.read_on && " | "}
                          {!notification.read_on && (
                            <span
                              onClick={async () => {
                                const res = await RequestServer(
                                  APIRoutes.NOTIFICATIONS +
                                    "/unread" +
                                    "?ids=" +
                                    notification.id,
                                  "PATCH",
                                );
                                if (res.success) {
                                  setData(
                                    data.map((n: any) =>
                                      n.id === notification.id
                                        ? {
                                            ...n,
                                            read_on: new Date(),
                                          }
                                        : n,
                                    ),
                                  );
                                }
                              }}
                              style={{
                                color: "var(--green-color)",
                                cursor: "pointer",
                              }}
                            >
                              Mark as read
                            </span>
                          )}
                        </div>
                      </>
                    ) : (
                      <>
                        <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
                          {notification.title}
                        </div>
                         <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                        <div>
                          <span>
                            {dayjs(notification.created_at).fromNow()}
                          </span>
                          {!notification.read_on && " | "}
                          {!notification.read_on && (
                            <span
                              onClick={async () => {
                                const res = await RequestServer(
                                  APIRoutes.NOTIFICATIONS +
                                    "/unread" +
                                    "?ids=" +
                                    notification.id,
                                  "PATCH",
                                );
                                if (res.success) {
                                  setData(
                                    data.map((n: any) =>
                                      n.id === notification.id
                                        ? {
                                            ...n,
                                            read_on: new Date(),
                                          }
                                        : n,
                                    ),
                                  );
                                }
                              }}
                              style={{
                                color: "var(--green-color)",
                                cursor: "pointer",
                              }}
                            >
                              Mark as read
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                ))}
              {data.length === 0 && (
                <div
                  style={{
                    padding: "0.5rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.75rem",
                    textAlign: "center",
                    height: "100%",
                  }}
                >
                  No notifications
                </div>
              )}
            </Box>
          )}
          {notificationState === "Unread" && (
            <Box
              sx={
                unreadNotifications.length > 0
                  ? {
                      position: "relative",
                      height: "100%",
                      maxHeight: unreadNotifications.length ? "20rem" : "25rem",
                      overflowY: "auto",
                    }
                  : {
                      position: "relative",
                      height: "100%",
                      maxHeight: unreadNotifications.length
                        ? "21.5rem"
                        : "26rem",
                      overflowY: "auto",
                    }
              }
            >
              {unreadNotifications.length > 0 &&
                unreadNotifications.map((notification: any, index: number) => (
                  <div
                    key={index}
                    onClick={async () => {
                      const res = await RequestServer(
                        APIRoutes.NOTIFICATIONS +
                          "/read" +
                          "?ids=" +
                          notification.id,
                        "PATCH",
                      );
                      if (res.success) {
                        setData(
                          data.map((n: any) =>
                            n.id === notification.id
                              ? {
                                  ...n,
                                  read_on: new Date()
                                    .toISOString()
                                    .slice(0, 19)
                                    .replace("T", " "),
                                }
                              : n,
                          ),
                        );
                      }
                    }}
                    style={unreadNotificationStyle}
                    onMouseOver={(e) => {
                      (
                        e.currentTarget.firstChild! as HTMLElement
                      ).style.backgroundColor = "rgba(0,0,0,0.05)";
                    }}
                    onMouseOut={(e) => {
                      (
                        e.currentTarget.firstChild! as HTMLElement
                      ).style.backgroundColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                      }}
                    ></div>
                    {notification.url ? (
                      <><Link
                        to={notification.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                          position: "relative",
                        }}
                      >
                        <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
                          {notification.title}
                        </div>
                         <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                      </Link>
                        <div>
                          <span>
                            {dayjs(notification.created_at).fromNow()}
                          </span>
                          {!notification.read_on && " | "}
                          {!notification.read_on && (
                            <span
                              onClick={async () => {
                                const res = await RequestServer(
                                  APIRoutes.NOTIFICATIONS +
                                    "/unread" +
                                    "?ids=" +
                                    notification.id,
                                  "PATCH",
                                );
                                if (res.success) {
                                  setData(
                                    data.map((n: any) =>
                                      n.id === notification.id
                                        ? {
                                            ...n,
                                            read_on: new Date(),
                                          }
                                        : n,
                                    ),
                                  );
                                }
                              }}
                              style={{
                                color: "var(--green-color)",
                                cursor: "pointer",
                              }}
                            >
                              Mark as read
                            </span>
                          )}
                        </div></>
                    ) : (
                      <>
                        <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
                          {notification.title}
                        </div>
                         <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                        <div>
                          <span>
                            {dayjs(notification.created_at).fromNow()}
                          </span>{" "}
                          |{" "}
                          <span
                            onClick={async () => {
                              const res = await RequestServer(
                                APIRoutes.NOTIFICATIONS +
                                  "/unread" +
                                  "?ids=" +
                                  notification.id,
                                "PATCH",
                              );
                              if (res.success) {
                                setData(
                                  data.map((n: any) =>
                                    n.id === notification.id
                                      ? {
                                          ...n,
                                          read_on: new Date(),
                                        }
                                      : n,
                                  ),
                                );
                              }
                            }}
                            style={{
                              color: "var(--green-color)",
                              cursor: "pointer",
                            }}
                          >
                            Mark as read
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              {unreadNotifications.length === 0 && (
                <div
                  style={{
                    padding: "0.5rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.75rem",
                    textAlign: "center",
                    height: "100%",
                  }}
                >
                  No unread notifications
                </div>
              )}
            </Box>
          )}
          {notificationState === "Read" && (
            <Box
              sx={{
                position: "relative",
                height: "100%",
                maxHeight: unreadNotifications.length ? "22rem" : "26.5rem",
                overflowY: "auto",
              }}
            >
              {readNotifications.length > 0 &&
                readNotifications.map((notification: any, index: number) => (
                  <div
                    key={index}
                    style={readNotificationStyle}
                    onMouseOver={(e) => {
                      (
                        e.currentTarget.firstChild! as HTMLElement
                      ).style.backgroundColor = "rgba(0,0,0,0.05)";
                    }}
                    onMouseOut={(e) => {
                      (
                        e.currentTarget.firstChild! as HTMLElement
                      ).style.backgroundColor = "transparent";
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                      }}
                    ></div>
                    {notification.url ? (
                      <Link
                        to={notification.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                          position: "relative",
                        }}
                      >
                        <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
                          {notification.title}
                        </div>
                         <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                        <div>{dayjs(notification.created_at).fromNow()}</div>
                      </Link>
                    ) : (
                      <>
                        <div style={{ fontSize: "1rem", fontWeight: "bold" }}>
                          {notification.title}
                        </div>
                         <div dangerouslySetInnerHTML={{ __html: notification.body }} />
                        <div>
                          <span>
                            {dayjs(notification.created_at).fromNow()}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                ))}

              {readNotifications.length === 0 && (
                <div
                  style={{
                    padding: "0.5rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "0.75rem",
                    textAlign: "center",
                    height: "100%",
                  }}
                >
                  No notifications
                </div>
              )}
            </Box>
          )}
          {notificationState !== "Read" && unreadNotifications.length > 0 && (
            <div
              style={{
                padding: "0.5rem",
                fontSize: "0.75rem",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                zIndex: 10,
                color: "var(--green-color)",
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",
                position: "sticky",
                bottom: 0,
                background: "rgba(0,0,0,0.035)",
              }}
            >
              <span
                onClick={markAllAsRead}
                style={{ cursor: "pointer", fontWeight: "bold" }}
              >
                Mark all as read
              </span>
            </div>
          )}
        </Box>
      </Menu>

      {notificationSettings.state &&
        <NotificationSelectionDialog 
          isOpen={notificationSettings.state}
          data={notificationSettings.data || undefined}
          handleClose={() => setNotificationSettings((prev) => ({...prev, state: false}))}
          handleDataChange={async (data: any) => {
            setNotificationSettings((prev) => ({...prev, data}))
            await fetchData()
          }}
        />
      }
    </React.Fragment>
  );
}

const readNotificationStyle = {
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  color: "rgba(0, 0, 0, 0.54)",
  fontSize: "0.75rem",
  padding: "0.5rem 1rem",
  position: "relative" as "relative",
  cursor: "pointer",
};

const unreadNotificationStyle = {
  background: "#fffaee",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "0.75rem",
  padding: "0.5rem 1rem",
  position: "relative" as "relative",
  cursor: "pointer",
};
